import { Routes, Route, Navigate } from 'react-router-dom'
import { ConsoleShell, SidebarProvider, ProtectedRoute } from './components/layout'
import {
  LoginPage,
  RegisterPage,
  MFAPage,
  CallbackPage,
  AcceptInvitePage,
  // Org pages
  OrgsListPage,
  CreateOrgPage,
  OrgDashboardPage,
  OrgBillingPage,
  // Apps pages
  AppsListPage,
  CreateAppPage,
  AppDetailLayout,
  AppOverviewPage,
  AppUsersPage,
  AppRolesPage,
  AppScopesPage,
  AppOAuthPage,
  AppWebhooksPage,
  AppMetersPage,
  AppAnalyticsPage,
  AppSettingsPage,
  // Team pages
  TeamLayout,
  TeamMembersPage,
  TeamInvitesPage,
  TeamRolesPage,
  // Settings pages
  SettingsLayout,
  GeneralSettingsPage,
  BrandingSettingsPage,
  DomainsSettingsPage,
  AuthSettingsPage,
  PaymentsSettingsPage,
  DangerSettingsPage,
} from './pages'

function App() {
  return (
    <SidebarProvider>
      <Routes>
        {/* Public auth routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/mfa" element={<MFAPage />} />
        <Route path="/auth/callback" element={<CallbackPage />} />
        <Route path="/invites/accept" element={<AcceptInvitePage />} />

        {/* Protected routes with ConsoleShell */}
        <Route
          element={
            <ProtectedRoute>
              <ConsoleShell />
            </ProtectedRoute>
          }
        >
          {/* Orgs list - root */}
          <Route path="/" element={<OrgsListPage />} />
          <Route path="/orgs" element={<Navigate to="/" replace />} />
          
          {/* Create org - MUST be before :orgSlug */}
          <Route path="/orgs/new" element={<CreateOrgPage />} />

          {/* Org-level routes */}
          <Route path="/orgs/:orgSlug">
            {/* Dashboard */}
            <Route index element={<OrgDashboardPage />} />

            {/* Apps */}
            <Route path="apps">
              <Route index element={<AppsListPage />} />
              <Route path="new" element={<CreateAppPage />} />

              {/* App detail with tabs */}
              <Route path=":appId" element={<AppDetailLayout />}>
                <Route index element={<AppOverviewPage />} />
                <Route path="users" element={<AppUsersPage />} />
                <Route path="roles" element={<AppRolesPage />} />
                <Route path="scopes" element={<AppScopesPage />} />
                <Route path="oauth" element={<AppOAuthPage />} />
                <Route path="webhooks" element={<AppWebhooksPage />} />
                <Route path="meters" element={<AppMetersPage />} />
                <Route path="analytics" element={<AppAnalyticsPage />} />
                <Route path="settings" element={<AppSettingsPage />} />
              </Route>
            </Route>

            {/* Team */}
            <Route path="team" element={<TeamLayout />}>
              <Route index element={<TeamMembersPage />} />
              <Route path="invites" element={<TeamInvitesPage />} />
              <Route path="roles" element={<TeamRolesPage />} />
            </Route>

            {/* Settings */}
            <Route path="settings" element={<SettingsLayout />}>
              <Route index element={<GeneralSettingsPage />} />
              <Route path="branding" element={<BrandingSettingsPage />} />
              <Route path="domains" element={<DomainsSettingsPage />} />
              <Route path="auth" element={<AuthSettingsPage />} />
              <Route path="payments" element={<PaymentsSettingsPage />} />
              <Route path="danger" element={<DangerSettingsPage />} />
            </Route>

            {/* Billing */}
            <Route path="billing" element={<OrgBillingPage />} />
          </Route>
        </Route>

        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </SidebarProvider>
  )
}

export default App
